import { createConsumer } from "@rails/actioncable"

// One ActionCable consumer for the chat, shared by every room visit.
let consumer
export function chatConsumer() {
  return (consumer ??= createConsumer())
}
